import { formatArrayForSelect } from '../../../../../common/select/select';
import { LATINA_COUNTRY_CODE } from '../../../../../constants/latina-country';
import serializeQueryParams from '../../../../../utils/url/serialize-query-params';
import {
    KUSHKI_ALLOWED_METHODS,
    KUSHKI_METHODS, KushkiDataType, KushkiPaymentRequestType,
    KushkiResponse,
    LATINA_DOC_TYPES,
    WORLD_DOCUMENT_DATA
} from '../constants/kushki';
import { KushkiCardType, KushkiCashType, KushkiTransferType } from '../types/kushki-types';
import { PAYMENT_METHOD_KEYS } from '../../../../../constants/payment-method-keys';
import { getKushkiCardToken } from '../kushki-process/card';
import { getKushkiCashToken } from '../kushki-process/cash';
import { getKushkiTransferToken } from '../kushki-process/transfer';


export const findKushkiStartedValue = (allowedPaymentMethods: string[]): string => {
    const queryParams = serializeQueryParams();
    let value = '';

    if (
        queryParams.defaultPaymentMethod &&
        allowedPaymentMethods.includes(queryParams.defaultPaymentMethod as string)
    ) {
        value = queryParams.defaultPaymentMethod as string;
    }

    KUSHKI_ALLOWED_METHODS.forEach((allowed) => {
        if (!value) {
            allowedPaymentMethods.find((backItem) => {
                if (backItem === allowed) {
                    value = allowed;
                }

                return '';
            });
        }
    });

    return value;
};

export const getDocumentTypeData = (region: string) => formatArrayForSelect(WORLD_DOCUMENT_DATA[region]);
export const updateDocumentTypeData = (region: LATINA_COUNTRY_CODE) => {
    if (region === LATINA_COUNTRY_CODE.EC) {
        return ecuadorDocumentTypeCash();
    }

    return getDocumentTypeData(region);
};
export const getCurrentTypeOfData = (
    type: KUSHKI_METHODS,
    region: LATINA_COUNTRY_CODE
): KushkiCardType & KushkiCashType & KushkiTransferType => {
    let value;

    if (type === KUSHKI_METHODS.KUSHKI_CARD) {
        value = {
            cvc: '',
            firstName: '',
            lastName: '',
            number: '',
            postDate: ''
        };
    } else if (type === KUSHKI_METHODS.KUSHKI_CASH) {
        value = {
            documentNumber: '',
            documentType: updateDocumentTypeData(region)[0].value,
            firstName: '',
            lastName: ''
        };
    } else {
        value = {
            bankId: '0',
            documentNumber: '',
            documentType: getDocumentTypeData(region)[0].value,
            name: '',
            reference: '',
            userType: '0'
        };
    }

    return value as never;
};

export const isNeedValidateKushkiForm = (paymentMethod: PAYMENT_METHOD_KEYS, country: string) => {
    return !(paymentMethod === PAYMENT_METHOD_KEYS.KUSHKI_CARD && country === LATINA_COUNTRY_CODE.CL);
};

export const validateKushkiForm = (
    type: KUSHKI_METHODS,
    kushkiData: KushkiDataType,
    region: string
): string[] => {
    const errors = [];

    if (type === KUSHKI_METHODS.KUSHKI_CASH) {
        // @ts-ignore
        !kushkiData.firstName && errors.push('firstName');
        // @ts-ignore
        !kushkiData.lastName && errors.push('lastName');
        // @ts-ignore
        !kushkiData.documentNumber && errors.push('documentNumber');
    } else if (type === KUSHKI_METHODS.KUSHKI_TRANSFER) {
        // @ts-ignore
        !kushkiData.documentNumber && errors.push('documentNumber');
        // @ts-ignore
        region === LATINA_COUNTRY_CODE.CO && kushkiData.bankId === '0' && errors.push('bankId');
    } else {
        // @ts-ignore
        !kushkiData.firstName && errors.push('firstName');
        // @ts-ignore
        !kushkiData.lastName && errors.push('lastName');
        // @ts-ignore
        !kushkiData.postDate && errors.push('postDate');
        // @ts-ignore
        !kushkiData.cvc && errors.push('cvc');
        // @ts-ignore
        !kushkiData.number && errors.push('number');
    }

    return errors;
};

export const getTransferData = (kushkiData: KushkiTransferType, region: string) => {
    const value = kushkiData;

    if (region === LATINA_COUNTRY_CODE.CO) {
        delete value.bankId;

        return value;
    }

    return value;
};
export const ecuadorDocumentTypeCash = () =>
    // @ts-ignore
    formatArrayForSelect([LATINA_DOC_TYPES.PP, LATINA_DOC_TYPES.RUC, LATINA_DOC_TYPES.CI]);

export const getMobilePathParams = (isObj = false) => {
    if (isObj) {
        const mobileParams: { isAndroid?: boolean; mobileApp?: boolean } = {};

        if (serializeQueryParams().isAndroid) {
            mobileParams.isAndroid = true;
        }

        if (serializeQueryParams().mobileApp) {
            mobileParams.mobileApp = true;
        }

        return mobileParams;
    }

    let mobileParams = '';

    if (serializeQueryParams().isAndroid) {
        mobileParams = '&isAndroid=true';
    }

    if (serializeQueryParams().mobileApp) {
        mobileParams = `${mobileParams}&mobileApp=true`;
    }

    return mobileParams;
};

export const getKushkiPaymentRequest = (props: KushkiPaymentRequestType): Promise<KushkiResponse> => {
    switch (props.paymentMethod) {
        case PAYMENT_METHOD_KEYS.KUSHKI_CARD:
            return getKushkiCardToken(props) as Promise<KushkiResponse>;
        case PAYMENT_METHOD_KEYS.KUSHKI_CASH:
            return getKushkiCashToken(props) as Promise<KushkiResponse>;
        case PAYMENT_METHOD_KEYS.KUSHKI_TRANSFER:
            return getKushkiTransferToken(props) as Promise<KushkiResponse>;
        default:
            return Promise.resolve({ endpoint: '', error: new Error('Failed') });
    }
};
